export class FilmListPropsApi {
    /**
     * Toggle film list into carousel or grid mode.
     */
    gridMode: boolean = false

    /**
     * Show all categories tab in the filter.
     */
    showAllTab: boolean = false

    /**
     * Title displayed when film data failed to load from the API.
     */
    failedToLoadDataTitle: string = 'Sorry, something went wrong.'

    /**
     * Message displayed when film data failed to load from the API.
     */
    failedToLoadDataMessage: string = 'Refresh your browser to try loading films again.'

    /**
     * Generic title displayed when there are no films and no filters applied.
     */
    noFilmsTitle: string = 'Sorry, there are no films!'

    /**
     * Title displayed when there are no films for the selected filter option.
     */
    noFilmsForFilterOptionTitle: string = 'There are no "${label}" films.'

    /**
     * Message displayed when there are no films for the selected filter option.
     */
    noFilmsForFilterOptionMessage: string = 'Choose another filter option to view films.'

    /**
     * The label on the 'clear button' shown when there are no films for the selected filters.
     */
    noFilmsForFilterClearButtonLabel: string = 'Clear all filters'

    /**
     * Message displayed when there are no films for the selected filters.
     */
    noFilmsForMultipleFiltersMessage: string = 'There are no results matching the selected filters.'

    /**
     * The optional label shown on the play trailer button.
     */
    playTrailerButtonLabel?: string = 'Play trailer'

    /**
     * Label text for the trailer video player error message title.
     */
    failedToLoadTrailerTitle: string = 'Sorry, something went wrong.'

    /**
     * Label text for the trailer video player error reload button.
     */
    failedToLoadTrailerRetryButtonLabel: string = 'Retry'
    
    /**
     * The format of the release date displayed under each film.
     */
    releaseDateFormat: string = '${date|d|D MMMM YYYY}'

    /**
     * Identifies the component on a digital sales channel
     */
    componentId?: string

    /**
     * The maximum number of films to display
     */
    maximumFilms?: number = 10
}
